import React from 'react';
import { Link } from 'react-router-dom';

const BlogPostFullwidthThreeCol = () => {
    return(
    <>
    {/*Blog Section*/}
    <section className="section-padding-five blog-section section-padding-all">
      <div className="default-container">
        <div className="row clearfix">
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-01-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Renovation</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Commercial design for project</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag - 27 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-02-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Maintenance</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Our interior design prediction</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-03-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Architecture Design</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Low cost interior designing</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-01-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Renovation</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Young new architects and their projects</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag - 27 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-02-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Maintenance</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">How it helps us achieve our goals</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-03-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Architecture Design</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Architecture and applying better</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-01-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Renovation</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Innovative use of marble and concrete today</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag - 27 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4 field-overlay-holder">
            <div className="img_blog field-overlay-inner">
              <div className="field-position-m field-mover-border">
                <img src="images/blog/bl-02-750x430.png" alt="" className="img-fluid mx-auto d-block" />
              </div>
            </div>
            <div className="blog-box-detail p-4">
              <div className="mt-0">
                <p className="labal text-muted">Building Maintenance</p>
                <h5 className="font-weight-bold"><Link to="#" className="read-more">Our most praised interior design projects</Link></h5>
                <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <ul className="cr-pagination-center">
              <li><Link to="#" title><i className="fa fa-angle-left" /></Link></li>
              <li className="active"><Link to="#" title>1</Link></li>
              <li><Link to="#" title>2</Link></li>
              <li><Link to="#" title>3</Link></li>
              <li><Link to="#" title><i className="fa fa-angle-right" /></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    {/*End Blog Section*/}
    </>
    )
}

export default BlogPostFullwidthThreeCol;